module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-range"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Range")]), _vm._v(" "), _c('p', {
    staticClass: "page-range-header"
  }, [_vm._v("基本功能")]), _vm._v(" "), _vm._l((_vm.cells1), function(item) {
    return _c('mt-cell', {
      attrs: {
        "title": item.title,
        "label": 'value:' + item.value
      }
    }, [_c('mt-range', {
      model: {
        value: (item.value),
        callback: function($$v) {
          item.value = $$v
        },
        expression: "item.value"
      }
    }, [(item.start) ? _c('div', {
      slot: "start"
    }, [_vm._v(_vm._s(item.start))]) : _vm._e(), _vm._v(" "), (item.end) ? _c('div', {
      slot: "end"
    }, [_vm._v(_vm._s(item.end))]) : _vm._e()])], 1)
  }), _vm._v(" "), _c('p', {
    staticClass: "page-range-header"
  }, [_vm._v("自定义")]), _vm._v(" "), _vm._l((_vm.cells2), function(item) {
    return _c('mt-cell', {
      attrs: {
        "title": item.title,
        "label": 'value:' + item.value
      }
    }, [_c('mt-range', {
      attrs: {
        "min": item.min || 0,
        "max": item.max || 100,
        "step": item.step || 1,
        "bar-height": item.barHeight || 1,
        "disabled": item.disabled
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          item.value = $$v
        },
        expression: "item.value"
      }
    }, [(item.start) ? _c('div', {
      slot: "start"
    }, [_vm._v(_vm._s(item.start))]) : _vm._e(), _vm._v(" "), (item.end) ? _c('div', {
      slot: "end"
    }, [_vm._v(_vm._s(item.end))]) : _vm._e()])], 1)
  }), _vm._v(" "), _c('p', {
    staticClass: "page-range-header"
  }, [_vm._v("场景举例")]), _vm._v(" "), _vm._l((_vm.cells3), function(item) {
    return _c('mt-cell', {
      attrs: {
        "title": item.title,
        "label": 'value:' + item.value
      }
    }, [_c('mt-range', {
      attrs: {
        "min": item.min || 0,
        "max": item.max || 100,
        "step": item.step || 1
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          item.value = $$v
        },
        expression: "item.value"
      }
    }, [(item.start) ? _c('div', {
      style: ({
        'font-size': item.start + 'px'
      }),
      slot: "start"
    }, [_vm._v(_vm._s(item.start))]) : _vm._e(), _vm._v(" "), (item.end) ? _c('div', {
      style: ({
        'font-size': item.end + 'px'
      }),
      slot: "end"
    }, [_vm._v(_vm._s(item.end))]) : _vm._e()])], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-509ffe5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/range.vue
// module id = 290
// module chunks = 0